var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "windows" },
    _vm._l(Object.keys(_vm.windows), function (type, index) {
      return _c("Window", {
        key: _vm.windows[type].id,
        attrs: {
          type: type,
          title: _vm.getTitle(type),
          description: _vm.getDescription(type),
          width: _vm.getWindowWidth(type, index),
          "z-index": _vm.getWindowZIndex(index, type),
          loading: _vm.getStatus(type),
          "full-show": _vm.getFullShow(type),
          footer: _vm.getFooterEnabled(type),
          payload: _vm.getPayload(type),
          window: _vm.windows[type],
          "auto-close": _vm.getAutoClose(type),
        },
        on: { close: _vm.closeWindow },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }